import React from 'react';
import { connect } from 'react-redux';
import { Snackbar, Alert } from '@mui/material';

const Errors = ({errors}) => {
  return <div>
          {errors.length > 0 ? 
                <Snackbar
                    open={true}
                    autoHideDuration={6000}
                    onClose={()=>{}}
                >  
                    <Alert severity="error" >
                        {errors[errors.length-1]?.message}
                    </Alert>
                </Snackbar> : <></>
        }
  </div>;
};

const mapStateToProps = (state) => ({
    errors: state.error.errors
});


export default connect(mapStateToProps)(Errors);
